<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->
<template>
  <svg class="live" :class="position" width="46px" height="16px" viewBox="0 0 46 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->
    <desc>Live</desc>
    <title>Live</title>
    <defs></defs>
    <rect id="Rectangle-2" fill-opacity="0.5" fill="#000000" x="0" y="0" width="46" height="16" rx="3"></rect>
    <text id="LIVE" font-family="Roboto-BoldItalic, Roboto" font-size="12" font-style="italic" font-weight="bold" fill="#FFFFFF">
      <tspan x="16" y="12">LIVE</tspan>
    </text>
    <circle id="Oval-2" fill="#FF3B30" cx="9" cy="8" r="4"></circle>
  </svg>
</template>
<script>
export default {
  name: 'Live',
  props: {
    position: {
      default: 'top-right',
      type: String,
    },
  },
};
</script>
